(function() {
  var SimplifyOperation, iterateLayers;

  SimplifyOperation = App.load('core::leaflet/SimplifyOperation');

  iterateLayers = function(layer, callback) {
    if (callback == null) {
      callback = function() {
        return void 0;
      };
    }
    if (layer.feature != null) {
      return callback(layer);
    } else if (layer.eachLayer != null) {
      return layer.eachLayer(function(l) {
        return iterateLayers(l, callback);
      });
    }
  };

  L.FeatureGroup.prototype.recursiveEachLayer = function(callback) {
    if (callback == null) {
      callback = function() {
        return void 0;
      };
    }
    return iterateLayers(this, callback);
  };


  /*
  
   * Clone Geometry methods.
   * this covers all the cases we are using (where we need cloning).
   * If people try cloning and it fails.. welll.... you should stop.
   * Or write cloneGeom methods for whatever weird geometry you are
   * trying to clone
   */

  L.LatLng.prototype.cloneGeom = function() {
    var geom;
    geom = new L.LatLng(this.lat, this.lng);
    if (this._cloneProperties != null) {
      geom._cloneProperties = $.extend({}, this._cloneProperties);
    }
    return geom;
  };

  L.Polygon.prototype.cloneGeom = function() {
    var hole, holearr, i, j, k, len, len1, len2, m, newpath, newpoly, ref, ref1, ref2;
    newpath = [];
    ref = this._latlngs;
    for (j = 0, len = ref.length; j < len; j++) {
      i = ref[j];
      newpath.push(i.cloneGeom());
    }
    newpoly = new L.Polygon(newpath, this.options);
    newpoly._holes = [];
    newpoly.isValid = (ref1 = this.isValid) != null ? ref1 : true;
    if (this._holes != null) {
      ref2 = this._holes;
      for (k = 0, len1 = ref2.length; k < len1; k++) {
        hole = ref2[k];
        holearr = [];
        for (m = 0, len2 = hole.length; m < len2; m++) {
          i = hole[m];
          holearr.push(i.cloneGeom());
        }
        newpoly._holes.push(holearr);
      }
    }
    if (this._cloneProperties != null) {
      newpoly._cloneProperties = $.extend({}, this._cloneProperties);
    }
    return newpoly;
  };

  L.FeatureGroup.prototype.cloneGeom = function() {
    var newfg;
    newfg = new L.FeatureGroup([]);
    this.eachLayer(function(l) {
      if (l.cloneGeom != null) {
        return newfg.addLayer(l.cloneGeom());
      } else {
        console.log("Tried to cloneGeom on layer that doesn't have it:");
        return console.log(l);
      }
    });
    if (this._cloneProperties != null) {
      newfg._cloneProperties = $.extend({}, this._cloneProperties);
    }
    return newfg;
  };


  /*
  
   * Little hack for polygon
   * Makes it so we can iterate over every point (including holes)
   * of the polygon
   */

  L.Polygon.prototype.eachPoint = function(cb) {
    var hole, i, j, k, len, len1, ref, ref1, results, v;
    ref = this._latlngs;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      v = ref[i];
      cb.apply(this, [i, v]);
    }
    if (this._holes != null) {
      ref1 = this._holes;
      results = [];
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        hole = ref1[k];
        results.push((function() {
          var len2, m, results1;
          results1 = [];
          for (i = m = 0, len2 = hole.length; m < len2; i = ++m) {
            v = hole[i];
            results1.push(cb.apply(this, [i, v]));
          }
          return results1;
        }).call(this));
      }
      return results;
    }
  };

  L.FeatureGroup.prototype.simplify = function(tolerance) {
    return this.eachLayer(function(l) {
      if (l.simplify != null) {
        return l.simplify(tolerance);
      }
    });
  };

  L.FeatureGroup.prototype.cleanUp = function() {
    return this.eachLayer((function(_this) {
      return function(l) {
        if (l instanceof L.Polygon) {
          if (l._latlngs.length < 3) {
            _this.removeLayer(l);
          }
        }
        if (l.cleanUp != null) {
          return l.cleanUp();
        }
      };
    })(this));
  };

  L.Polygon.prototype.rotate = function(angle, center) {
    var i, ind, j, len, ref;
    if (center == null) {
      center = null;
    }
    if (center == null) {
      center = this.getBounds().getCenter();
    }
    L.GeoUtil.rotatePoints(center, angle, this._latlngs);
    if (this._holes != null) {
      ref = this._holes;
      for (ind = j = 0, len = ref.length; j < len; ind = ++j) {
        i = ref[ind];
        L.GeoUtil.rotatePoints(center, i);
      }
    }
    return this.redraw();
  };

  L.Draw.NewPoly = L.Draw.Polygon.extend({
    _getTooltipText: function() {
      var ref, ref1, subtext, text;
      text = '';
      subtext = '';
      if (((ref = this._markers) != null ? ref.length : void 0) === 0) {
        text = L.drawLocal.draw.handlers.polygon.tooltip.start;
      } else if (((ref1 = this._markers) != null ? ref1.length : void 0) < 3) {
        text = L.drawLocal.draw.handlers.polygon.tooltip.cont;
        subtext = this._getMeasurementString();
      } else {
        text = 'Click the blue dot to close the shape.';
      }
      return {
        text: text,
        subtext: subtext
      };
    },
    _finishShape: function() {
      var kinks, latlngs, points, polygon;
      latlngs = this._poly.getLatLngs();
      if (latlngs.length > 2) {
        latlngs.push(latlngs[0]);
        points = latlngs.map((function(_this) {
          return function(latlng) {
            var point;
            point = _this._map.latLngToLayerPoint(latlng);
            return [point.x, point.y];
          };
        })(this));
        polygon = turf.polygon([points]);
        kinks = turf.kinks(polygon);
        latlngs.pop();
        if (kinks.features.length > 0) {
          this._showErrorTooltip();
          return;
        }
      }
      return L.Draw.Polygon.prototype._finishShape.call(this);
    },
    addVertex: function(latLng) {
      var previousLatLng;
      if (this._markers.length > 0) {
        previousLatLng = this._markers[this._markers.length - 1].getLatLng();
        if (latLng.lat === previousLatLng.lat && latLng.lng === previousLatLng.lng) {
          return;
        }
      }
      return L.Draw.Polygon.prototype.addVertex.call(this, latLng);
    },
    _updateFinishHandler: function() {
      var markerCount;
      markerCount = this._markers.length;
      if (markerCount === 1) {
        return this._markers[0].on('click', this._finishShape, this);
      }
    }
  });

  L.Draw.CustomRectangle = L.Draw.Rectangle.extend({
    _hasAncestor: (function(_this) {
      return function(el, cls) {
        while (!el.classList.contains(cls)) {
          el = el.parentElement;
          if (!el) {
            break;
          }
        }
        return el;
      };
    })(this),
    _onMouseUp: function(e) {
      if (!this._shape && !this._isCurrentlyTwoClickDrawing) {
        this._isCurrentlyTwoClickDrawing = true;
        return;
      }
      if (this._isCurrentlyTwoClickDrawing && !this._hasAncestor(e.target, 'leaflet-map-pane')) {
        return;
      }
      if (this._shape) {
        return L.Draw.SimpleShape.prototype._onMouseUp.call(this);
      }
    },
    _getTooltipText: function() {
      var area, latLngs, shape, showArea, subtext, tooltipText;
      tooltipText = L.Draw.SimpleShape.prototype._getTooltipText.call(this);
      shape = this._shape;
      showArea = this.options.showArea;
      if (shape) {
        latLngs = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs();
        area = L.GeometryUtil.geodesicArea(latLngs);
        subtext = showArea ? L.GeometryUtil.readableArea(area, this.options.metric) : '';
      }
      return {
        text: this._isCurrentlyTwoClickDrawing ? 'Click again to finish drawing' : tooltipText.text,
        subtext: subtext
      };
    }
  });

}).call(this);
